var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import styled from 'styled-components';
import { Box } from '../../Box';
import CardDrawer from './CardDrawer';
import { get } from '../..';
import { CardLabel, CardValue } from './shared';
var StyledCardData = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    padding: ", " ", " 0 ", ";\n    color: ", ";\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n  }\n"], ["\n  && {\n    padding: ", " ", " 0 ", ";\n    color: ", ";\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n  }\n"])), get.space('xs'), get.space('xs'), get.space('xs'), get.colors('slate-5'));
var getDisplayedCells = function (showFromMdDown, row) {
    var base = row.cells.slice(1);
    var showAll = !showFromMdDown.length;
    // if nothing is included in the `showFromMdDown` array, then return all the
    // cells
    if (showAll) {
        return base;
    }
    // otherwise, only return those cells that have a matching header name in
    // the `showFromMdDown` array
    return base.reduce(function (acc, cell) {
        var column = cell.column;
        var shouldShow = typeof column.Header === 'string' &&
            showFromMdDown.includes(column.Header);
        if (shouldShow) {
            return __spreadArray(__spreadArray([], __read(acc), false), [cell], false);
        }
        return acc;
    }, []);
};
var CardData = function (_a) {
    var row = _a.row, _b = _a.showFromMdDown, showFromMdDown = _b === void 0 ? [] : _b, drawer = _a.drawer, drawerProps = _a.drawerProps, cellDrawerProps = _a.cellDrawerProps, _c = _a.mdDownDrawerName, mdDownDrawerName = _c === void 0 ? 'Details' : _c, _d = _a.mdDownColumnFullWidth, mdDownColumnFullWidth = _d === void 0 ? false : _d;
    var displayedCells = getDisplayedCells(showFromMdDown, row);
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledCardData, { mdDownColumnFullWidth: mdDownColumnFullWidth }, displayedCells.map(function (cell) {
            var column = cell.column;
            return (React.createElement(Box, { key: column.id, display: "flex", flexDirection: "column", flex: "0 ".concat(mdDownColumnFullWidth ? '100%' : '50%'), mb: "xs" },
                React.createElement(CardLabel, { flex: "0 50%" }, column.render('Header')),
                React.createElement(CardValue, { flex: "0 50%", alignItems: "flex-end" }, cell.render('Cell', cellDrawerProps))));
        })),
        drawer && (React.createElement(CardDrawer, __assign({ mdDownDrawerName: mdDownDrawerName, drawer: drawer, row: row }, drawerProps)))));
};
export default CardData;
var templateObject_1;
//# sourceMappingURL=CardData.js.map